module.exports = __webpack_public_path__ + "static/media/  (14).7e19a7a9.jpg";